import { useDispatch } from 'react-redux';
import { SubmitHandler, useController, useForm, UseFormReturn } from 'react-hook-form';
import { authRequestLoginLink, authResetLoginLinkRequest } from '../core/actions';
import { useState } from 'react';

export const useAuthForm = () => {
  const dispatch = useDispatch();

  const [isLoginLinkRequested, setIsLoginLinkRequested] = useState(false);

  const form: UseFormReturn<any> = useForm<any>({
    defaultValues: {
      email: '',
    },
  });

  const onSubmit: SubmitHandler<any> = async ({ email }: any) => {
    try {
      dispatch(authResetLoginLinkRequest());

      dispatch(
        authRequestLoginLink({
          email: email,
        }),
      );
    } catch (error) {
      // Failure is surfaced via Redux state (`auth.error`); intentionally
      // swallowed here so the `finally` block can still flip the UI to the
      // "login link sent" state without a duplicate toast.
    } finally {
      setIsLoginLinkRequested(true);
    }
  };

  const emailController = useController({
    name: 'email',
    control: form.control,
    defaultValue: '',
  });

  return {
    form,

    onSubmit,

    emailController,

    isLoginLinkRequested,
    setIsLoginLinkRequested,
  };
};
